import Cookies from 'js-cookie';
import app from '../../../02-components/apps/app/app.es6';

let pageInitialized = false;

document.addEventListener("DOMContentLoaded", function(){
    if(pageInitialized) return; // Prevent double DOM load in Storybook
    pageInitialized = true;

    let myapplistCount = app.getMyAppList() ? JSON.parse(app.getMyAppList()).length : 0;
    
    // Dynamically update Docker + Share Hero title on page load
    updateMyAppListDocker(myapplistCount);
    updateMyAppListShareTitle(myapplistCount);
    toggleMyAppListActionBtns(myapplistCount);

    //Email form collapse/expand actions
    const emailForm = document.getElementById('myAppListEmail');
    const actionButtons = document.querySelector('.my-app-list__share__actions .usa-button-group');

    if(emailForm) {
        emailForm.addEventListener('hidden.bs.collapse', function(){
            actionButtons.style.display = "flex";
        });
    
        emailForm.addEventListener('show.bs.collapse', function(){
            actionButtons.style.display = "none";
        });
    }
});

document.addEventListener("myapplist.changed", function(e){
    let myapplistCount = app.getMyAppList() ? JSON.parse(app.getMyAppList()).length : 0;

    // Dynamically update Docker + Share Hero Title when MyAppList gets updates
    updateMyAppListDocker(myapplistCount);
    updateMyAppListShareTitle(myapplistCount);
    toggleMyAppListActionBtns(myapplistCount);
});

jQuery(document).on("mouseup",".myapplist__toggle",function() {
	const appID = parseInt(this.dataset.appId);
	app.updateMyAppList(appID);
});

function updateMyAppListDocker(int) {
    const myapplistCount = int;

     // Update MyAppList Docker Status when MyAppList udpates
     if( document.querySelector('#my-app-list__docker__action') ) {
        const dockerButton = document.querySelector('#my-app-list__docker__action');
        
        switch(myapplistCount) {
            case 0:
                dockerButton.disabled = true;
                dockerButton.innerText = 'Add Apps to Share';
                break;
    
            case 1:
                dockerButton.disabled = false;
                dockerButton.innerText = 'Review List of 1 App';
                break;
    
            default:
                dockerButton.disabled = false;
                dockerButton.innerText = 'Review List of ' + myapplistCount + ' Apps';
        }
    };
}

function updateMyAppListShareTitle(int) {
    const myapplistCount = int;
    const heading = document.querySelector('.path-my-app-list-share .hero__title');

    if(!heading) { return false; }

    switch (myapplistCount) {
        case 0:
            heading.innerText = 'Sharing No Apps';
            break;
        case 1:
            heading.innerText = 'Share ' + myapplistCount + ' App';
            break;
        default:
            heading.innerText = 'Share ' + myapplistCount +' Apps';
    }
}

function toggleMyAppListActionBtns(int) {
    const myapplistCount = int;
    const actionBtnPrint = document.querySelector('.my-app-list__share__actions .usa-button--print');
    const actionBtnEmail = document.querySelector('.my-app-list__share__actions .usa-button--email');

    if(!actionBtnPrint && !actionBtnEmail) { return; }

    // Disable Print and Email button if there are no apps to share
    actionBtnPrint.disabled = (myapplistCount == 0);
    actionBtnEmail.disabled = (myapplistCount == 0);
}